import React, { lazy, useEffect } from 'react'
import { Navigate, useRoutes } from 'react-router'
import AuthenticationLayout from '../layout/AuthenticationLayout'
import Loadable from '../view/common/component/Loadable'
import Privacy from '../view/common/component/Privacy';

const SignIn = Loadable(lazy(() => import('../view/common/SignIn')));
const SignUp = Loadable(lazy(() => import('../view/common/SignUp')));
const MinimalLayout = Loadable(lazy(() => import('../layout/MinimalLayout')));
const Landing = Loadable(lazy(() => import('../view/common/Landing')));
const About = Loadable(lazy(() => import('../view/common/About')));
const ProductDetails = Loadable(lazy(() => import('../view/common/ProductDetails')));

const Subscription = Loadable(lazy(() => import('../view/seller/Subscription')));

export default function AuthenticationRoutes() {
  const token = localStorage.getItem('m-market-user-token');

  useEffect(()=>{        
    if(!token){
      authMiddleware();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const isAuthenticated = () => {
    // Return true if authenticated, false otherwise
    const authToken = localStorage.getItem('m-market-user-token');
    return authToken !== null;
  };

  const authMiddleware = () => {
      if (isAuthenticated()) {
        return;
      } else {      
        // Redirect to the home page indicating unauthenticated access
        return <Navigate to="/" replace />;
      }
  };
  
  const list = {
      children: [
        { path: '/', element: <MinimalLayout> <Landing/> </MinimalLayout>},
        { path: '/about', element: <MinimalLayout> <About/> </MinimalLayout>},
        { path: '/sign-in', element: <AuthenticationLayout> <SignIn /> </AuthenticationLayout> },
        { path: '/product-details/:id', element: <MinimalLayout> <ProductDetails /> </MinimalLayout> },
        { path: '/sign-up', element: <AuthenticationLayout> <SignUp/> </AuthenticationLayout> },
        { path: '/subscription', element: <MinimalLayout> <Subscription /> </MinimalLayout> },
        { path: '/privacy', element: <MinimalLayout> <Privacy/> </MinimalLayout>},
        { path: '*', element: <MinimalLayout> <Landing/> </MinimalLayout>},
    ]
  }
  return useRoutes([list])
}

